import React from 'react';

import { Checkbox, Table, Tooltip } from '@mantine/core';

import { PatientData } from '@/types/patientList';

import {
  ClinicCell,
  CurrentReportCell,
  OptionsCell,
  PatientCell,
  PreviousReportCell,
  StatusCell,
  TransmissionDateCell
} from '../cells';

import styles from './PatientTableRow.module.scss';

interface PatientRowProps {
  patient: PatientData;
  isSelected: boolean;
  onToggle: (patient: PatientData) => void;
}

export const PatientTableRow: React.FC<PatientRowProps> = ({ patient, isSelected, onToggle }) => {
  const hasReports = !!patient.previousReport;

  return (
    <Table.Tr className={styles.patientRow}>
      <Table.Td>
        <Tooltip label="No previous report available" disabled={hasReports} withArrow>
          {/* Tooltip needs a wrapper div when child is disabled */}
          <div style={{ display: 'inline-block' }}>
            <Checkbox
              checked={isSelected}
              onChange={() => hasReports && onToggle(patient)}
              disabled={!hasReports}
              styles={{ input: { cursor: hasReports ? 'pointer' : 'not-allowed' } }}
            />
          </div>
        </Tooltip>
      </Table.Td>
      <Table.Td>
        <PatientCell patient={patient} />
      </Table.Td>
      <Table.Td>
        <StatusCell
          status={patient.status}
          statusReason={patient.statusReason}
          statusOtherReason={patient.statusOtherReason}
          statusEndDate={patient.statusEndDate}
          statusStartDate={patient.statusStartDate}
          statusUpdatedAt={patient.statusUpdatedAt}
        />
      </Table.Td>
      <Table.Td>
        <ClinicCell clinicName={patient.clinicName} />
      </Table.Td>
      <Table.Td>
        <TransmissionDateCell transmissionAt={patient.lastTransmission?.transmissionAt || null} />
      </Table.Td>
      <Table.Td>
        <PreviousReportCell report={patient.previousReport} />
      </Table.Td>
      <Table.Td>
        <CurrentReportCell report={patient.currentReport} />
      </Table.Td>
      <Table.Td>
        <OptionsCell patient={patient} />
      </Table.Td>
    </Table.Tr>
  );
};
